export const DEALER_USERNAME_PLACEHOLDER = "Enter the Dealer username you'd like to view";
export const ROLE_ASSUMTION = 'role-assumption';
export const ROLE_ASSUMPTION_ROUTE = '/role-assumption';
export const USERNAME_MAX_LENGTH_ERROR = 'Username must not exceed 50 characters';
export const INVALID_ROLE_ASSUMPTION_USER_ERROR = 'Invalid username for role assumption. Please verify and try again.';
